// ============================================================
// dmtOperatorConfigs.js — single source of truth, all 5 operators
// ============================================================

import {
    POST_DMT_PAY_SPRINT_CONFIRM_INITIATE_TRANSACTION,
    GET_DMT_NEW_BANK_LIST,
    GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
    IFSC_CODE_VERIFY,
    POST_DMT_FAILED_BY_PARTNER,
    POST_INSTANT_PAY_DELETE_BENEFICIARY,
    UPDATE_DMT_JIO_BENEFICIARY_STATUS,

    GET_DMT_INSTANT_PAY_BENEFICIARY_LIST,
    POST_DMT_INSTANT_PAY_CUSTOMER_INFO,
    POST_DMT_INSTANT_PAY_ADD_BENEFICIARY,
    POST_DMT_INSTANT_PAY_BENEFICIARY_VERIFY,
    POST_DMT_INSTANT_PAY_INITIATE_TRANSACTION,
    POST_DMT_INSTANT_PAY_GENERATE_TRANSACTION,
    POST_DMT_INSTANT_PAY_PAYMENT_TRANSFER,
    UPDATE_DMT_INSTANT_PAY_BENEFICIARY_STATUS,
    UPDATE_DMT_INSTANT_PAY_BENEFICIARY_DETAIL,
    POST_INSTANT_PAY_DELETE_BENEFICIARY_VERIFY,

    GET_DMT_NSDL_BENEFICIARY_LIST,
    POST_DMT_NSDL_CUSTOMER_INFO,
    POST_DMT_NSDL_ADD_BENEFICIARY,
    POST_DMT_NSDL_BENEFICIARY_VERIFY,
    POST_DMT_NSDL_INITIATE_TRANSACTION,
    POST_DMT_NSDL_GENERATE_TRANSACTION,
    POST_DMT_NSDL_PAYMENT_TRANSFER,
    UPDATE_DMT_NSDL_BENEFICIARY_STATUS,
    UPDATE_DMT_NSDL_BENEFICIARY_DETAIL,
    POST_DMT_NSDL_DELETE_BENE_VERIFY,

    GET_DMT_JIO_BENEFICIARY_LIST,
    POST_DMT_JIO_CUSTOMER_INFO,
    POST_DMT_JIO_ADD_BENEFICIARY,
    POST_DMT_JIO_BENEFICIARY_VERIFY,
    POST_DMT_JIO_INITIATE_TRANSACTION,
    POST_DMT_JIO_GENERATE_TRANSACTION,
    POST_DMT_JIO_PAYMENT_TRANSFER,
    UPDATE_DMT_JIO_BENEFICIARY_DETAIL,
    POST_DMT_JIO_DELETE_BENE_VERIFY,

    FINO_IMW_GET_BENEFICIARY_LIST,
    FINO_IMW_ADD_BENEFICIARY,
    FINO_IMW_DELETE_BENEFICIARY,
    FINO_IMW_INITIATE,
    FINO_IMW_GENERATE,
    FINO_IMW_PAYMENT_TRANSFER,

    AIRTEL_IMW_GET_BENEFICIARY_LIST,
    AIRTEL_IMW_ADD_BENEFICIARY,
    AIRTEL_IMW_DELETE_BENEFICIARY,
    AIRTEL_IMW_INITIATE,
    AIRTEL_IMW_GENERATE,
    AIRTEL_IMW_PAYMENT_TRANSFER,
} from '../../Utils/appConstants';

export const DMT_OPERATOR = {
    INSTANT_PAY: 'INSTANT_PAY',
    NSDL: 'NSDL',
    JIO: 'JIO',
    FINO: 'FINO',
    AIRTEL: 'AIRTEL',
};

// Capability presets — these drive UI behaviour in BeneficiaryList.js
const LEGACY_CAPS = {
    requiresDeleteOtp: true,           // delete → OTP modal → verify
    verifyViaBankPopup: true,          // "Get Name" opens bank-selection popup
    syncViaCustomerInfo: true,         // POST customerInfo, not ?sync=true
    updateNameViaDetailEndpoint: true, // update name via updateBeneficiaryDetail
    usesImwBeneId: false,              // always shows Send (never Update)
    payloadShape: 'LEGACY',            // mobile / name / beneficiaryMobileNumber
};

const IMW_CAPS = {
    requiresDeleteOtp: false,
    verifyViaBankPopup: false,
    syncViaCustomerInfo: false,
    updateNameViaDetailEndpoint: false,
    usesImwBeneId: true,
    payloadShape: 'IMW',
};

export const DMT_OPERATOR_CONFIGS = {

    [DMT_OPERATOR.INSTANT_PAY]: {
        displayName: 'InstantPay',
        serviceName: 'DMT1',
        bankListMode: 'DMT1.0',
        messages: { headerSubtitle: 'Manage InstantPay DMT beneficiaries', importMode: 'DMT1.0' },
        ...LEGACY_CAPS,
        endpoints: {
            beneficiaryList: GET_DMT_INSTANT_PAY_BENEFICIARY_LIST,
            customerInfo: POST_DMT_INSTANT_PAY_CUSTOMER_INFO,
            addBeneficiary: POST_DMT_INSTANT_PAY_ADD_BENEFICIARY,
            verifyBeneficiary: POST_DMT_INSTANT_PAY_BENEFICIARY_VERIFY,
            initiate: POST_DMT_INSTANT_PAY_INITIATE_TRANSACTION,
            generate: POST_DMT_INSTANT_PAY_GENERATE_TRANSACTION,
            paymentTransfer: POST_DMT_INSTANT_PAY_PAYMENT_TRANSFER,
            updateBeneficiaryStatus: UPDATE_DMT_INSTANT_PAY_BENEFICIARY_STATUS,
            updateBeneficiaryDetail: UPDATE_DMT_JIO_BENEFICIARY_DETAIL,
            verifyDeleteBeneficiary: POST_INSTANT_PAY_DELETE_BENEFICIARY_VERIFY,
        },
    },

    [DMT_OPERATOR.NSDL]: {
        displayName: 'NSDL',
        serviceName: 'DMT1',
        bankListMode: 'DMT1.0',
        messages: { headerSubtitle: 'Manage NSDL DMT beneficiaries', importMode: 'DMT1.0' },
        ...LEGACY_CAPS,
        endpoints: {
            beneficiaryList: GET_DMT_NSDL_BENEFICIARY_LIST,
            customerInfo: POST_DMT_NSDL_CUSTOMER_INFO,
            addBeneficiary: POST_DMT_NSDL_ADD_BENEFICIARY,
            verifyBeneficiary: POST_DMT_NSDL_BENEFICIARY_VERIFY,
            initiate: POST_DMT_NSDL_INITIATE_TRANSACTION,
            generate: POST_DMT_NSDL_GENERATE_TRANSACTION,
            paymentTransfer: POST_DMT_NSDL_PAYMENT_TRANSFER,
            updateBeneficiaryStatus: UPDATE_DMT_NSDL_BENEFICIARY_STATUS,
            updateBeneficiaryDetail: UPDATE_DMT_JIO_BENEFICIARY_DETAIL,
            verifyDeleteBeneficiary: POST_DMT_NSDL_DELETE_BENE_VERIFY,
        },
    },

    [DMT_OPERATOR.JIO]: {
        displayName: 'JIO',
        serviceName: 'DMT1',
        bankListMode: 'DMT1.0',
        messages: { headerSubtitle: 'Manage JIO DMT beneficiaries', importMode: 'DMT1.0' },
        ...LEGACY_CAPS,
        endpoints: {
            beneficiaryList: GET_DMT_JIO_BENEFICIARY_LIST,
            customerInfo: POST_DMT_JIO_CUSTOMER_INFO,
            addBeneficiary: POST_DMT_JIO_ADD_BENEFICIARY,
            verifyBeneficiary: POST_DMT_JIO_BENEFICIARY_VERIFY,
            initiate: POST_DMT_JIO_INITIATE_TRANSACTION,
            generate: POST_DMT_JIO_GENERATE_TRANSACTION,
            paymentTransfer: POST_DMT_JIO_PAYMENT_TRANSFER,
            updateBeneficiaryStatus: UPDATE_DMT_JIO_BENEFICIARY_STATUS,
            updateBeneficiaryDetail: UPDATE_DMT_JIO_BENEFICIARY_DETAIL,
            verifyDeleteBeneficiary: POST_DMT_JIO_DELETE_BENE_VERIFY,
        },
    },

    [DMT_OPERATOR.FINO]: {
        displayName: 'Fino',
        serviceName: 'FINO',
        bankListMode: 'DMT1.0',
        messages: { headerSubtitle: 'Manage your Fino DMT beneficiaries', importMode: 'DMT1.0' },
        ...IMW_CAPS,
        endpoints: {
            beneficiaryList: FINO_IMW_GET_BENEFICIARY_LIST,
            addBeneficiary: FINO_IMW_ADD_BENEFICIARY,
            deleteBeneficiary: FINO_IMW_DELETE_BENEFICIARY,
            initiate: FINO_IMW_INITIATE,
            generate: FINO_IMW_GENERATE,
            paymentTransfer: FINO_IMW_PAYMENT_TRANSFER,
            updateBeneficiaryDetail: UPDATE_DMT_JIO_BENEFICIARY_DETAIL,

        },
    },

    [DMT_OPERATOR.AIRTEL]: {
        displayName: 'Airtel',
        serviceName: 'AIRTEL',
        bankListMode: 'DMT1.0',
        messages: { headerSubtitle: 'Manage your Airtel DMT beneficiaries', importMode: 'DMT1.0' },
        ...IMW_CAPS,
        endpoints: {
            beneficiaryList: AIRTEL_IMW_GET_BENEFICIARY_LIST,
            addBeneficiary: AIRTEL_IMW_ADD_BENEFICIARY,
            deleteBeneficiary: AIRTEL_IMW_DELETE_BENEFICIARY,
            initiate: AIRTEL_IMW_INITIATE,
            generate: AIRTEL_IMW_GENERATE,
            paymentTransfer: AIRTEL_IMW_PAYMENT_TRANSFER,
            updateBeneficiaryDetail: UPDATE_DMT_JIO_BENEFICIARY_DETAIL,

        },
    },
};

export const DMT_SHARED_ENDPOINTS = {
    confirmInitiateTransaction: POST_DMT_PAY_SPRINT_CONFIRM_INITIATE_TRANSACTION,
    bankList: GET_DMT_NEW_BANK_LIST,
    getCustomerBankName: GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
    ifscVerify: IFSC_CODE_VERIFY,
    failByPartner: POST_DMT_FAILED_BY_PARTNER,
    deleteBeneficiary: POST_INSTANT_PAY_DELETE_BENEFICIARY,
    toggleStatus: UPDATE_DMT_JIO_BENEFICIARY_STATUS,
};